// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: NQkWwR4UVBrr
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import UploadCsv from "../../UploadCsv"; // plasmic-import: YamPMiUoqMNr/component
import AddClientButton from "../../AddClientButton"; // plasmic-import: uj7QoqqfY_Ws/component
import ClientsListCard from "../../ClientsListCard"; // plasmic-import: 74swX8o1_CEp/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicClientsList.module.css"; // plasmic-import: NQkWwR4UVBrr/css

createPlasmicElementProxy;

export const PlasmicClientsList__VariantProps = new Array();

export const PlasmicClientsList__ArgProps = new Array();

const $$ = {};

function PlasmicClientsList__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          sty.root
        )}
      >
        <Sidebar
          data-plasmic-name={"sidebar"}
          data-plasmic-override={overrides.sidebar}
          className={classNames("__wab_instance", sty.sidebar)}
        />

        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <TopBar
            data-plasmic-name={"topBar"}
            data-plasmic-override={overrides.topBar}
            className={classNames("__wab_instance", sty.topBar)}
          />

          <Stack__
            as={"div"}
            data-plasmic-name={"figmaPaste"}
            data-plasmic-override={overrides.figmaPaste}
            hasGap={true}
            className={classNames(projectcss.all, sty.figmaPaste)}
          >
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {hasVariant(globalVariants, "screen", "large")
                ? "Debtors"
                : "Clients"}
            </div>
            <UploadCsv
              data-plasmic-name={"uploadButton"}
              data-plasmic-override={overrides.uploadButton}
              className={classNames("__wab_instance", sty.uploadButton)}
            />

            <AddClientButton
              data-plasmic-name={"addClientButton"}
              data-plasmic-override={overrides.addClientButton}
              className={classNames("__wab_instance", sty.addClientButton)}
            />

            <div
              data-plasmic-name={"searchVertStack"}
              data-plasmic-override={overrides.searchVertStack}
              className={classNames(projectcss.all, sty.searchVertStack)}
            />
          </Stack__>
          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"figmaPaste2"}
              data-plasmic-override={overrides.figmaPaste2}
              hasGap={true}
              className={classNames(projectcss.all, sty.figmaPaste2)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fnFhP
                )}
              >
                {"Name"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__n0YYm
                )}
              >
                {"Email"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xhk7J
                )}
              >
                {"Created"}
              </div>
            </Stack__>
            <Stack__
              as={"div"}
              data-plasmic-name={"clientsListStack"}
              data-plasmic-override={overrides.clientsListStack}
              hasGap={true}
              className={classNames(projectcss.all, sty.clientsListStack)}
            >
              <ClientsListCard
                className={classNames(
                  "__wab_instance",
                  sty.clientsListCard__jNEj
                )}
                clientName={"Family Vineyard Collectives"}
              />

              <ClientsListCard
                className={classNames(
                  "__wab_instance",
                  sty.clientsListCard__qhp7D
                )}
              />
            </Stack__>
            <div
              data-plasmic-name={"paginationStack"}
              data-plasmic-override={overrides.paginationStack}
              className={classNames(projectcss.all, sty.paginationStack)}
            >
              <div
                data-plasmic-name={"prevButton"}
                data-plasmic-override={overrides.prevButton}
                className={classNames(projectcss.all, sty.prevButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__pjGlB
                  )}
                >
                  {"Previous"}
                </div>
              </div>
              <div
                data-plasmic-name={"nextButton"}
                data-plasmic-override={overrides.nextButton}
                className={classNames(projectcss.all, sty.nextButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cL0Ci
                  )}
                >
                  {"Next"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "uploadButton",
    "addClientButton",
    "searchVertStack",
    "vertStack",
    "figmaPaste2",
    "clientsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  sidebar: ["sidebar"],
  freeBox: [
    "freeBox",
    "topBar",
    "figmaPaste",
    "title",
    "uploadButton",
    "addClientButton",
    "searchVertStack",
    "vertStack",
    "figmaPaste2",
    "clientsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  topBar: ["topBar"],
  figmaPaste: [
    "figmaPaste",
    "title",
    "uploadButton",
    "addClientButton",
    "searchVertStack"
  ],

  title: ["title"],
  uploadButton: ["uploadButton"],
  addClientButton: ["addClientButton"],
  searchVertStack: ["searchVertStack"],
  vertStack: [
    "vertStack",
    "figmaPaste2",
    "clientsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  figmaPaste2: ["figmaPaste2"],
  clientsListStack: ["clientsListStack"],
  paginationStack: ["paginationStack", "prevButton", "nextButton"],
  prevButton: ["prevButton"],
  nextButton: ["nextButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicClientsList__ArgProps,
          internalVariantPropNames: PlasmicClientsList__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicClientsList__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicClientsList";
  } else {
    func.displayName = `PlasmicClientsList.${nodeName}`;
  }
  return func;
}

export const PlasmicClientsList = Object.assign(
  // Top-level PlasmicClientsList renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    freeBox: makeNodeComponent("freeBox"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title: makeNodeComponent("title"),
    uploadButton: makeNodeComponent("uploadButton"),
    addClientButton: makeNodeComponent("addClientButton"),
    searchVertStack: makeNodeComponent("searchVertStack"),
    vertStack: makeNodeComponent("vertStack"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    clientsListStack: makeNodeComponent("clientsListStack"),
    paginationStack: makeNodeComponent("paginationStack"),
    prevButton: makeNodeComponent("prevButton"),
    nextButton: makeNodeComponent("nextButton"),
    // Metadata about props expected for PlasmicClientsList
    internalVariantProps: PlasmicClientsList__VariantProps,
    internalArgProps: PlasmicClientsList__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicClientsList;
/* prettier-ignore-end */
